// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"TaxiTab_PageHolder__3b1f6","TabsTitle":"TaxiTab_TabsTitle__2cbw7","normal":"TaxiTab_normal__2OpCP","checked":"TaxiTab_checked__E7G31"};